import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import TextInputField from 'components/inputs/TextInputField';
import { ROUTING_NUMBER_LENGTH } from 'features/my-profile/become-fundraiser/context/becomeFundraiserUtils';
import { paymentService } from 'services/payment/paymentService';

interface Props {
  routingNumber?: string;
  bankName?: string;
  onRoutingNameChange: (value?: string) => void;
  onBankNameChange: (bankName?: string) => void;
  errorMessage?: string;
}

const RoutingNumberInput = ({
  routingNumber,
  bankName,
  onRoutingNameChange,
  onBankNameChange,
  errorMessage,
}: Props) => {
  const { t } = useTranslation('myProfile');

  const resolveBankName = (bankName?: string) => {
    if (!bankName) return '';
    if (bankName.toLowerCase() === 'unknown') return t('become-fundraiser.verify-routing-number.unknown');
    return bankName;
  };

  useEffect(() => {
    if (routingNumber && routingNumber.length === ROUTING_NUMBER_LENGTH) {
      paymentService
        .fetchBankName(routingNumber)
        .then(response => onBankNameChange(resolveBankName(response.data.bankName)))
        .catch(() => onBankNameChange(''));
    } else onBankNameChange('');
  }, [routingNumber]);

  return (
    <TextInputField
      value={routingNumber || ''}
      onChange={onRoutingNameChange}
      placeholder={t('become-fundraiser.verify-routing-number.routing-number-placeholder')}
      errorMessage={errorMessage}
      successMessage={bankName}
      maxLength={ROUTING_NUMBER_LENGTH}
      testId={'routing-number-field'}
    />
  );
};

export default RoutingNumberInput;
